module.exports = __webpack_public_path__ + "img/deleteIcon.a4a1d3e1.svg";